import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import App from "./App";
import { postLogin } from "./apiService";
import { jwtDecode } from "jwt-decode";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../src/components/pages/Logo/favicon.png";
import "./Login.css";
import { FaUser, FaLock, FaEye, FaEyeSlash, FaHeartbeat, FaStethoscope, FaHospital, FaBuilding, FaMapMarkerAlt, FaArrowRight } from "react-icons/fa";
import { FaUserDoctor } from "react-icons/fa6";

const LoginForm = () => {
  const history = useHistory();
  const { isAuthenticated, login } = useAuth();
  const [step, setStep] = useState(1); // 1: Medical Code, 2: User Type Selection, 3: Login/Appointment/Register, 4: Book Appointment
  const [userType, setUserType] = useState(""); // "staff" or "patient"
  const [isNewPatient, setIsNewPatient] = useState(false);
  const [medicalCode, setMedicalCode] = useState("");
  const [companyType, setCompanyType] = useState(""); // "Company" or "Patient" from API response
  const [showPassword, setShowPassword] = useState(false);
  const [companyCode, setCompanyCode] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [branchId, setBranchId] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [branchstate, setbranchstate] = useState('');

  // Patient Registration Fields
  const [patientData, setPatientData] = useState({
    mrdNo: "",
    name: "",
    address1: "",
    address2: "",
    contact1: "",
    contact2: "",
    panNumber: "",
    location: "",
    zipCode: "",
  });

  // Appointment Fields
  const [patientId, setPatientId] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [appointmentDate, setAppointmentDate] = useState("");
  const [appointmentTime, setAppointmentTime] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [isValidating, setIsValidating] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const location = useLocation();
  const [companyCodeValidated, setCompanyCodeValidated] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const [showCompanyCards, setShowCompanyCards] = useState(false);


  // Mock doctors list - replace with API call
  const doctors = [
    { id: 1, name: "Dr. Smith - Cardiology" },
    { id: 2, name: "Dr. Johnson - Pediatrics" },
    { id: 3, name: "Dr. Williams - General Medicine" },
    { id: 4, name: "Dr. Brown - Dermatology" },
  ];

  const handleLogin = async () => {
    try {

      if (!companyCodeValidated) {
        throw new Error('Branch code validation is required.');
      }

      const jwtToken = await performLogin();
      const responseData = jwtDecode(jwtToken);
      const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
      const permissions = Object.keys(responseData).filter(
        (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
      );

      let isSuper = false;
      if (responseData.isSuperAdmin.toLowerCase() === "true") {
        isSuper = true;
      }

      // Convert isAppointmentNeeded from "Yes"/"No" to boolean
      let isAppointmentNeeded = false;
      if (responseData.isAppointmentNeeded && responseData.isAppointmentNeeded.toLowerCase() === "yes") {
        isAppointmentNeeded = true;
      }

      if (isSuper == false) {
        const parsedCompanyId = parseInt(responseData.companyId, 10);

        if (parsedCompanyId === companyId) {
          login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, companyName, permissions, jwtToken, responseData.roleName, branchstate, responseData.username, isAppointmentNeeded);
          const redirectParam = new URLSearchParams(location.search).get("redirect");
          const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
          history.replace(redirectPath);
        }
        else {
          toast.error('Invalid User !', {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
      else {
        login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, companyName, permissions, jwtToken, responseData.roleName, branchstate, responseData.username, isAppointmentNeeded);
        const redirectParam = new URLSearchParams(location.search).get("redirect");
        const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
        history.replace(redirectPath);
      }

    } catch (error) {
      toast.error('Login failed', {
        // position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const performLogin = async () => {
    const loginData = {
      UserName: username,
      Password: password,
      CompanyId: companyId,
      BranchId: branchId
    };

    const response = await postLogin('LoginApi', loginData);

    if (response.responseCode === '1111') {
      const jwtToken = response.response_data.token;

      return jwtToken;
    } else {
      throw new Error(response.Message);
    }
  };

  const handleCompanyValidation = async () => {
    try {
      if (!companyCode.trim()) {
        toast.error('Branch code is required.', {
          position: toast.POSITION.TOP_CENTER,
        });
      }

      if (companyCode.trim()) {

        const CompanyData = {
          BranchCode: companyCode,
        };

        const response = await postLogin('BranchLoginApi', CompanyData);

        if (response.responseCode === '1111') {
          setCompanyCodeValidated(true);
          setCompanyId(response.response_data.companyId)
          setBranchId(response.response_data.id)
          setCompanyName(response.response_data.name);
          setbranchstate(response.response_data.branchstate)
          setShowCompanyCards(true); // Show company cards after successful validation
          setLoginFailed(false); // Reset loginFailed state
        } else {
          //throw new Error(response.Message);
          toast.error('Invalid Branch code', {
            position: toast.POSITION.TOP_CENTER,
          });
        }

      }

    } catch (error) {
      toast.error("Branch login failed", {
        //position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleProceedFromCards = () => {
    setShowCompanyCards(false);
    setStep(2);
  };

  const handleBackFromCards = () => {
    setShowCompanyCards(false);
    setCompanyCodeValidated(false);
    setCompanyCode('');
    setCompanyId('');
    setBranchId('');
    setCompanyName('');
    setbranchstate('');
  };

  const handleUserTypeSelection = (type, isNew = false) => {
    setUserType(type);
    setIsNewPatient(isNew);
    setStep(3);
  };

  const handlePatientDataChange = (e) => {
    const { name, value } = e.target;
    setPatientData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePatientRegistration = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    // Validate required fields
    if (!patientData.name || !patientData.contact1 || !patientData.address1) {
      toast.error("Please fill all required fields!", { position: "top-center" });
      setIsSaving(false);
      return;
    }

    // Mock API call - replace with actual registration API
    setTimeout(() => {
      const newPatientId = "PAT" + Math.floor(Math.random() * 10000);
      setPatientId(newPatientId);
      setContactNo(patientData.contact1);
      toast.success(`Patient registered successfully! Your Patient ID: ${newPatientId}`, {
        position: "top-center",
        autoClose: 5000
      });
      setIsSaving(false);
      setStep(4); // Move to appointment booking
    }, 1500);
  };

  const handlePatientAppointment = async (e) => {
    e.preventDefault();

    if (!patientId || !contactNo || !appointmentDate || !appointmentTime || !selectedDoctor) {
      toast.error("Please fill all fields!", { position: "top-center" });
      return;
    }

    setIsSaving(true);

    // Mock appointment booking - replace with actual API call
    setTimeout(() => {
      const doctorName = doctors.find(d => d.id === parseInt(selectedDoctor))?.name || "Doctor";
      setSuccessMessage(`Appointment booked successfully with ${doctorName} on ${appointmentDate} at ${appointmentTime}`);
      setShowSuccessModal(true);
      setIsSaving(false);
    }, 1000);
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    // Reset to medical code screen
    setStep(1);
    setUserType("");
    setIsNewPatient(false);
    setMedicalCode("");
    setCompanyType("");
    setPatientId("");
    setContactNo("");
    setAppointmentDate("");
    setAppointmentTime("");
    setSelectedDoctor("");
    setPatientData({
      mrdNo: "",
      name: "",
      address1: "",
      address2: "",
      contact1: "",
      contact2: "",
      panNumber: "",
      location: "",
      zipCode: "",
    });
  };

  const handleBack = () => {
    if (step === 3) {
      if (companyType === "Company") {
        // For company, go back to medical code
        setStep(1);
        setUserType("");
        setMedicalCode("");
        setCompanyType("");
      } else {
        // For patient, go back to patient type selection
        setStep(2);
        setUserType("");
      }
    } else if (step === 2) {
      setStep(1);
      setMedicalCode("");
      setCompanyType("");
    }
  };

  if (isAuthenticated) {
    return <App />;
  }

  // Company Information Cards Component
  const CompanyInfoCards = () => (
    <div className="company-cards-container">
      <div className="cards-grid">
        <div className="info-card">
          <FaHospital className="card-icon" />
          <h3>Branch Code</h3>
          <p>{companyCode || 'N/A'}</p>
        </div>

        <div className="info-card">
          <FaBuilding className="card-icon" />
          <h3>Branch Name</h3>
          <p>{companyName || 'N/A'}</p>
        </div>

        <div className="info-card">
          <FaMapMarkerAlt className="card-icon" />
          <h3>Location</h3>
          <p>{branchstate || 'N/A'}</p>
        </div>
      </div>
    </div>
  );



  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Segoe UI', sans-serif",
        overflow: "hidden",
        background: "linear-gradient(135deg, #072e35, #0e4b52)",
        color: "#fff",
      }}
    >
      {/* Decorative background splits & bubbles */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          overflow: "hidden",
          zIndex: 1,
        }}
      >
        {/* Left soft split */}
        <div
          style={{
            position: "absolute",
            left: "-10%",
            top: "-20%",
            width: "60vw",
            height: "120vh",
            background:
              "radial-gradient(circle at 20% 30%, rgba(30,200,190,0.12), transparent 18%), linear-gradient(180deg, rgba(30,200,190,0.06), transparent 40%)",
            transform: "rotate(-12deg)",
            filter: "blur(40px)",
            animation: "floatSlow 12s ease-in-out infinite",
          }}
        />
        {/* Right soft split */}
        <div
          style={{
            position: "absolute",
            right: "-12%",
            bottom: "-10%",
            width: "55vw",
            height: "110vh",
            background:
              "radial-gradient(circle at 80% 70%, rgba(120,90,255,0.09), transparent 18%), linear-gradient(180deg, rgba(120,90,255,0.04), transparent 40%)",
            transform: "rotate(8deg)",
            filter: "blur(40px)",
            animation: "floatSlowReverse 14s ease-in-out infinite",
          }}
        />

        {/* Floating bubbles (animated scale & translate + subtle opacity) */}
        <div
          style={{
            position: "absolute",
            left: "8%",
            top: "15%",
            width: 120,
            height: 120,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.06)",
            boxShadow: "0 8px 40px rgba(10,200,180,0.06)",
            transform: "translateZ(0)",
            animation: "bubbleMove 9s ease-in-out infinite",
          }}
        />
        <div
          style={{
            position: "absolute",
            right: "18%",
            top: "30%",
            width: 80,
            height: 80,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.04)",
            boxShadow: "0 6px 30px rgba(110,80,240,0.04)",
            animation: "bubbleMoveAlt 11s ease-in-out infinite",
          }}
        />
        <div
          style={{
            position: "absolute",
            right: "6%",
            bottom: "22%",
            width: 160,
            height: 160,
            borderRadius: "50%",
            background: "linear-gradient(135deg, rgba(26,188,156,0.06), rgba(46,204,113,0.03))",
            filter: "blur(6px)",
            animation: "bubbleFloatRotate 16s linear infinite",
            opacity: 0.95,
          }}
        />

        {/* Moving gradient strip */}
        <div
          style={{
            position: "absolute",
            left: "-40%",
            top: "60%",
            width: "160%",
            height: "18vh",
            background:
              "linear-gradient(90deg, rgba(20,198,169,0.05), rgba(123,97,255,0.05), rgba(20,198,169,0.05))",
            transform: "skewY(-6deg)",
            filter: "blur(18px)",
            animation: "stripSlide 18s linear infinite",
          }}
        />

        <style>
          {`
      @keyframes floatSlow {
        0% { transform: rotate(-12deg) translateY(0px); opacity:1; }
        50% { transform: rotate(-12deg) translateY(-22px); opacity:0.95; }
        100% { transform: rotate(-12deg) translateY(0px); opacity:1; }
      }
      @keyframes floatSlowReverse {
        0% { transform: rotate(8deg) translateY(0px); opacity:1; }
        50% { transform: rotate(8deg) translateY(26px); opacity:0.96; }
        100% { transform: rotate(8deg) translateY(0px); opacity:1; }
      }
      @keyframes bubbleMove {
        0% { transform: translateY(0) scale(1); opacity:0.9; }
        25% { transform: translateY(-18px) scale(1.06); opacity:1; }
        50% { transform: translateY(0) scale(1); opacity:0.92; }
        75% { transform: translateY(12px) scale(0.98); opacity:0.9; }
        100% { transform: translateY(0) scale(1); opacity:0.9; }
      }
      @keyframes bubbleMoveAlt {
        0% { transform: translate(0,0) scale(1); opacity:0.85; }
        40% { transform: translate(-10px,-26px) scale(1.08); opacity:1; }
        80% { transform: translate(6px,10px) scale(0.96); opacity:0.88; }
        100% { transform: translate(0,0) scale(1); opacity:0.85; }
      }
      @keyframes bubbleFloatRotate {
        0% { transform: rotate(0deg) translateY(0) scale(1); opacity:0.95; }
        50% { transform: rotate(120deg) translateY(-28px) scale(1.03); opacity:0.98; }
        100% { transform: rotate(360deg) translateY(0) scale(1); opacity:0.95; }
      }
      @keyframes stripSlide {
        0% { transform: translateX(-10%) skewY(-6deg); }
        100% { transform: translateX(10%) skewY(-6deg); }
      }
    `}
        </style>
      </div>

      <ToastContainer position="top-center" autoClose={3000} />
      {/* Medical Background Pattern */}
      <div className="medical-bg">
        <div className="medical-pattern"></div>
      </div>

      {/* Left Side - Branding */}
      <div className="login-left">
        <div className="branding-content">
          <div className="logo-container">
            <div className="logo-circle">
              <FaHeartbeat className="logo-heartbeat" />
            </div>
            <h1 className="brand-name">MediCare</h1>
          </div>
          <p className="brand-tagline">Smile Flow</p>
          <p className="brand-tagline">Your Health, Our Priority</p>
          <div className="feature-list">
            <div className="feature-item">
              <FaStethoscope className="feature-icon" />
              <span>Professional Healthcare Management</span>
            </div>
            <div className="feature-item">
              <FaUserDoctor className="feature-icon" />
              <span>Expert Medical Staff</span>
            </div>
            <div className="feature-item">
              <FaHospital className="feature-icon" />
              <span>Comprehensive Clinic Solutions</span>
            </div>
          </div>
        </div>
      </div>

      <div className="login-right">
        <div className="login-card">

          {/* Logo & Title */}

          <br />
          {!companyCodeValidated ? (
            <form className="login-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleCompanyValidation();
              }}
            >

              <div className="card-header">
                <h2 className="card-title" style={{ color: '#063c49' }}>Welcome to MediCare</h2>
                <p className="card-subtitle" style={{ color: '#063c49' }}>Enter your medical code to continue</p>
              </div>

              <div className="form-group">
                <label className="form-label">Medical Code</label>
                <div className={`input-wrapper ${companyCode ? 'has-value' : ''}`}>
                  <FaHospital className="input-icon" />
                  <input
                    type="text"
                    placeholder="Enter medical code"
                    value={companyCode}
                    onChange={(e) => setCompanyCode(e.target.value)}
                    className="input-field"
                    required
                  />
                </div>
              </div>

              <button type="submit" className="login-btn" disabled={isValidating}>
                <span>{isValidating ? "Validating..." : "Validate Code"}</span>
                <FaHeartbeat className="btn-icon" />
              </button>


              <div className="card-footer">
                <p className="footer-text">Secure healthcare management system</p>
              </div>

            </form>
          ) : (

            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleLogin();
              }}

            >
              <div className="card-header">
                <h2 className="card-title" style={{ color: '#063c49', fontFamily: 'sans-serif' }}>Staff Login</h2>
                <p className="card-subtitle" style={{ color: '#063c49' }}>Sign in to access your dashboard</p>
              </div>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleLogin();
                }}
                className="login-form"
              >
                <div className="form-group">
                  <label className="form-label">Username</label>
                  <div className={`input-wrapper ${username ? 'has-value' : ''}`}>
                    <FaUser className="input-icon" />
                    <input
                      type="text"
                      placeholder="Enter your username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      className="input-field"
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Password</label>
                  <div className={`input-wrapper ${password ? 'has-value' : ''}`}>
                    <FaLock className="input-icon" />
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="input-field"
                      required
                    />
                    <div
                      onClick={() => setShowPassword((prev) => !prev)}
                      className="eye-icon"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </div>
                  </div>
                </div>

              </form>
              <button type="submit" onClick={handleLogin}
                className="login-btn">
                <span>Sign In</span>
                <FaHeartbeat className="btn-icon" />
              </button>
            </form>
          )}

          {/* Animations */}
          <style>
            {`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }

      @keyframes fadeIn {
        from { opacity: 0; transform: scale(0.95); }
        to { opacity: 1; transform: scale(1); }
      }
    `}
          </style>

        </div>
      </div>
    </div>
  );
}
export default LoginForm;
